import { Link } from "@mui/material";
import React from "react";
import styled from "styled-components";
import "../App.css";

function Navbar() {
  return (
    <Container>
      <Wrap>
        <a href="/">
          <Logo className="main__logo" src={"/assests/Logo.png"} />
        </a>

        <Other>
          <a href="https://discord.gg/KnThpXuyHK">
            <SocialMedia className="social_media">
              <img src="/assests/icons8-discord-new.svg" alt="" />
            </SocialMedia>
          </a>
          <a href="https://twitter.com/ProjectAkira_">
            <SocialMedia>
              <img src="/assests/icons8-twitter.svg" alt="" />
            </SocialMedia>
          </a>
          <a href="https://www.instagram.com/projectakira_/">
            <SocialMedia>
              <img src="/assests/icons8-instagram.svg" alt="" />
            </SocialMedia>
          </a>
          {/* <a class="connect_btn" href="#"><ConnectButton>Connect wallet</ConnectButton></a> */}
        </Other>
      </Wrap>
    </Container>
  );
}

export default Navbar;
const Container = styled.header`
  position: absolute;
  z-index: 10000;
  width: 100%;
`;

const Wrap = styled.div`
  padding: 18px 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  @media (max-width: 700px) {
    padding: 0px 0;
  }
`;

const Logo = styled.img`
  height: auto;
  width: 100px;
  @media (max-width: 800px) {
    height: auto;
    width: 50px;
  }
`;
const Links = styled.div`
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    margin: 16px 0;
    color: #FFFFFF; 
    }
`;
const Other = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

const SocialMedia = styled.div`
  position: relative;
  // background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  transition: 0.3s;

  img {
    height: auto;
    width: 38px;
    border-radius: 0px;
  }
  @media (max-width: 800px) {
    img {
      height: auto;
      width: 18px;
    }
  }

  @media (max-width: 460px) {
    img {
      height: auto;
      width: 18px;
    }
  }
`;

const ConnectButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  // padding: 15px 28px 14px;
  width: 144px;
  height: 52px;
  border-radius: 0px;
  border: 1px solid #ffffff;
  margin: 10px 10px;
  background: #ffffff;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  outline-width: 0px;
  cursor: pointer;
  transition: 0.3s;
  :hover {
    background: #9000ff !important;
    color: white;
  }
  // line-height: 111.5%;
  @media (max-width: 700px) {
    min-width: 144px;
    max-width: 128px;
    width: 100%;
    font-size: 14px;
  }
`;
